import { z } from "zod";
const attributesMathSchema = z.object({
  caption: z.string().default(""),
  equation: z.string().default("")
});
export {
  attributesMathSchema
};
//# sourceMappingURL=attributes.js.map
